<template>
  <div class="configurator-step-mileage">
    <p>Bitte nenne uns den Kilometerstand des Fahrzeuges</p>
    <div class="form">
      <input type="text" v-mask="currencyMask" v-model="mileage" >
      <a
        href="#"
        class="submit"
        :class="isDisabled && 'disabled'"
        title="Weiter"
        tabindex="-1"
        @click.prevent="submit"
        v-bind:disabled="isDisabled"
        v-wave="{color: '#54a324',initialOpacity: 0.3,easing: 'ease-in'}"
      >
        Weiter
      </a>
    </div>
  </div>
</template>

<script>

import createNumberMask from 'text-mask-addons/dist/createNumberMask';
  const currencyMask = createNumberMask({
    prefix: '',
    allowDecimal: false,
    includeThousandsSeparator: true,
    allowNegative: false,
    integerLimit: 6,
    thousandsSeparatorSymbol: '.',
  });
  
export default {
  name: "ConfiguratorStepMileage",
  props: ["name", "options"],
  data: function() {
    return {
      mileage: null,
      currencyMask,
      myInputModel: ''
    };
  },
  computed: {
    isDisabled: function() {
      return (
        this.mileage == null ||
        this.mileage.length == 0 ||
        this.invalidMileage()
      );
    },
    isPristine: function() {
      return this.$store.state.pristine;
    }
  },
  methods: {
    invalidMileage: function() {
      return this.mileage.replace(/\./g, '').match(/\D/);
    },
    submit: function() {
      if (this.isDisabled) return false;
      this.$store.dispatch("selectOption", {
        name: this.name,
        value: this.mileage.replace(/\./g, '')
      });
    },
  },
  watch: {
    isPristine: function(value) {
      if (value) {
        this.mileage = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 20px;
  font-size: 14px;
  line-height: 20px;
}

.form {
  padding: 0 20px 20px 20px;
}

input[type="number"],
input[type="text"] {
  border: 1px solid #dadada;
  border-radius: 3px;
  padding: 0 10px;
  line-height: 40px;
  display: block;
  font-size: 14px;
  width: 100%;
  margin-bottom: 20px;
  height: 50px;
}

input[type="number"]:focus,
input[type="text"]:focus {
  outline: none;
}

.submit {
  height: auto;
  width: auto;
  font-size: 14px;
  line-height: 20px;
  display: block;
  width: 100%;
  border: 1px solid #54a324;
  color: #54a324;
  background: transparent;
  border-radius: 23px;
  padding: 12px;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  @media (hover: hover) {
    &:not(.disabled):hover {
      text-decoration: none;
      background-color: #eee;
    }
  }
}

.submit:focus {
  outline: none;
}


.submit.disabled {
  pointer-events: none;
  opacity: 0.3;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepMileage.vue